module.exports = __webpack_public_path__ + "static/media/gallery-12.4d328d3e.jpeg";